 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A00_COVER from '@/components/000_Cover'
 import A01_HALFTITLE from '@/components/001_Halftitle'
 import A02_FM01 from '@/components/002_FM01'
 import A03_TITLEPAGE from '@/components/003_Titlepage'
 import A04_COPYRIGHT from '@/components/004_Copyright'
 import A05_CONTENTS from '@/components/005_Contents'
 import A06_PREFACE from '@/components/006_Preface'
 import A07_CONSULTING_EDITORS from '@/components/007_Consulting_Editors'
 import A08_CONTRIBUTORS from '@/components/008_Contributors'
 import A09_ALPHABETICAL_LIST from '@/components/009_Alphabetical_List'
 import A10_TOPICAL_LIST from '@/components/010_Topical_List'
 import A11_MAP_LIST from '@/components/011_Map_List'
 import A12_CHRONOLOGY from '@/components/012_Chronology'
 import A13_ABBREVIATIONS from '@/components/013_Abbreviations'
 import A14_CHAPTER01 from '@/components/014_Chapter01'
 import A15_CHAPTER02 from '@/components/015_Chapter02'
 import A16_CHAPTER03 from '@/components/016_Chapter03'
 import A17_CHAPTER04 from '@/components/017_Chapter04'
 import A18_CHAPTER05 from '@/components/018_Chapter05'
 import A19_CHAPTER06 from '@/components/019_Chapter06'
 import A20_CHAPTER07 from '@/components/020_Chapter07'
 import A21_CHAPTER08 from '@/components/021_Chapter08'
 import A22_CHAPTER09 from '@/components/022_Chapter09'
 import A23_CHAPTER10 from '@/components/023_Chapter10'
 import A24_CHAPTER11 from '@/components/024_Chapter11'
 import A25_CHAPTER12 from '@/components/025_Chapter12'
 import A26_CHAPTER13 from '@/components/026_Chapter13'
 import A27_BM01 from '@/components/027_BM01'
 import A28_DICTIONARYA1 from '@/components/028_Dictionary-A1'
 import A28_DICTIONARYA2 from '@/components/028_Dictionary-A2'
 import A28_DICTIONARYA3 from '@/components/028_Dictionary-A3'
 import A29_DICTIONARYB from '@/components/029_Dictionary-B'
 import A30_DICTIONARYC from '@/components/030_Dictionary-C'
 import A31_DICTIONARYD from '@/components/031_Dictionary-D'
 import A32_DICTIONARYE1 from '@/components/032_Dictionary-E1'
 import A32_DICTIONARYE2 from '@/components/032_Dictionary-E2'
 import A33_DICTIONARYF from '@/components/033_Dictionary-F'
 import A34_DICTIONARYG from '@/components/034_Dictionary-G'
 import A35_DICTIONARYH from '@/components/035_Dictionary-H'
 import A36_DICTIONARYI from '@/components/036_Dictionary-I'
 import A37_DICTIONARYJ1 from '@/components/037_Dictionary-J1'
 import A37_DICTIONARYJ2 from '@/components/037_Dictionary-J2'
 import A38_DICTIONARYK from '@/components/038_Dictionary-K'
 import A39_DICTIONARYL from '@/components/039_Dictionary-L'
 import A40_DICTIONARYM1 from '@/components/040_Dictionary-M1'
 import A40_DICTIONARYM2 from '@/components/040_Dictionary-M2'
 import A41_DICTIONARYN from '@/components/041_Dictionary-N'
 import A42_DICTIONARYO from '@/components/042_Dictionary-O'
 import A43_DICTIONARYP1 from '@/components/043_Dictionary-P1'
 import A43_DICTIONARYP2 from '@/components/043_Dictionary-P2'
 import A43_DICTIONARYP3 from '@/components/043_Dictionary-P3'
 import A44_DICTIONARYQ from '@/components/044_Dictionary-Q'
 import A45_DICTIONARYR from '@/components/045_Dictionary-R'
 import A46_DICTIONARYS1 from '@/components/046_Dictionary-S1'
 import A46_DICTIONARYS2 from '@/components/046_Dictionary-S2'
 import A46_DICTIONARYS3 from '@/components/046_Dictionary-S3'
 import A47_DICTIONARYT from '@/components/047_Dictionary-T'
 import A48_DICTIONARYU from '@/components/048_Dictionary-U'
 import A49_DICTIONARYV from '@/components/049_Dictionary-V'
 import A50_DICTIONARYW from '@/components/050_Dictionary-W'
 import A51_DICTIONARYY from '@/components/051_Dictionary-Y'
 import A52_DICTIONARYZ from '@/components/052_Dictionary-Z'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/005_Contents",
 			"name" : "005_Contents",
 			"component" : A05_CONTENTS
 		},
 		{
 			"path" : "/006_Preface",
 			"name" : "006_Preface",
 			"component" : A06_PREFACE
 		},
 		{
 			"path" : "/007_Consulting_Editors",
 			"name" : "007_Consulting_Editors",
 			"component" : A07_CONSULTING_EDITORS
 		},
 		{
 			"path" : "/008_Contributors",
 			"name" : "008_Contributors",
 			"component" : A08_CONTRIBUTORS
 		},
 		{
 			"path" : "/009_Alphabetical_List",
 			"name" : "009_Alphabetical_List",
 			"component" : A09_ALPHABETICAL_LIST
 		},
 		{
 			"path" : "/010_Topical_List",
 			"name" : "010_Topical_List",
 			"component" : A10_TOPICAL_LIST
 		},
 		{
 			"path" : "/011_Map_List",
 			"name" : "011_Map_List",
 			"component" : A11_MAP_LIST
 		},
 		{
 			"path" : "/012_Chronology",
 			"name" : "012_Chronology",
 			"component" : A12_CHRONOLOGY
 		},
 		{
 			"path" : "/013_Abbreviations",
 			"name" : "013_Abbreviations",
 			"component" : A13_ABBREVIATIONS
 		},
 		{
 			"path" : "/014_Chapter01",
 			"name" : "014_Chapter01",
 			"component" : A14_CHAPTER01
 		},
 		{
 			"path" : "/015_Chapter02",
 			"name" : "015_Chapter02",
 			"component" : A15_CHAPTER02
 		},
 		{
 			"path" : "/016_Chapter03",
 			"name" : "016_Chapter03",
 			"component" : A16_CHAPTER03
 		},
 		{
 			"path" : "/017_Chapter04",
 			"name" : "017_Chapter04",
 			"component" : A17_CHAPTER04
 		},
 		{
 			"path" : "/018_Chapter05",
 			"name" : "018_Chapter05",
 			"component" : A18_CHAPTER05
 		},
 		{
 			"path" : "/019_Chapter06",
 			"name" : "019_Chapter06",
 			"component" : A19_CHAPTER06
 		},
 		{
 			"path" : "/020_Chapter07",
 			"name" : "020_Chapter07",
 			"component" : A20_CHAPTER07
 		},
 		{
 			"path" : "/021_Chapter08",
 			"name" : "021_Chapter08",
 			"component" : A21_CHAPTER08
 		},
 		{
 			"path" : "/022_Chapter09",
 			"name" : "022_Chapter09",
 			"component" : A22_CHAPTER09
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js